import React from "react"
import TableRow from "material-ui/Table/TableRow"
import EmployeeTimecardTableHeaderItem from "./EmployeeTimecardTableHeaderItem"
import AppStateStore from "../../stores/AppStateStore"
import moment from "moment"
import { ISuspensePunchData, ELoggedInUserType, EPunchSetApprovalType, ITimecardDay, IPayrollStatusDocument, IDate, IPunchSetDocument, ITimecardPriorPeriodData } from "../../models"
interface IProps {
    userId: string
    timecardPriorPeriodData: ITimecardPriorPeriodData
    fullPunchSets: IPunchSetDocument[]
    dailyNoteDates: IDate[]
    timecardDays: ITimecardDay[]
    lockData: IPayrollStatusDocument[]
    loggedInUserType: ELoggedInUserType
    filterByPunchHierarchy: boolean
    suspensePunchData: ISuspensePunchData

    openDailyHistoryDrawer(date: number): void
    handleApproveStatus(status: "unapprove" | "approve", dayOfWeekIndex: number, punchSetApprovalType: EPunchSetApprovalType): void

    priorPeriodAdjustMode: boolean
    allowPriorPeriodAdjust: boolean

    virtualTimecard: boolean
    handleOpenVirtualTimecardPopup(): void

    // if Job->Timecard, it's not full timecard object. so let's hide Info icon to show Notes, Audits and WorkHistory.
    hideInfoIcon?: boolean
}

const EmployeeTimecardTableHeader: React.SFC<IProps> = (props: IProps) => {
    const showApproveIconOnBottom = !props.priorPeriodAdjustMode && props.timecardDays.filter((item) => item.PunchSets && item.PunchSets.length > 0).length > 0 && AppStateStore.isLaptop()
    const startDayTime = props.timecardDays[0].LocalStartDayTime.endsWith("Z") ? props.timecardDays[0].LocalStartDayTime : props.timecardDays[0].LocalStartDayTime + "Z"
    const showCustomStartTime = moment(startDayTime).utc().hour() > 0
    let headerHeight = 97
    if (showCustomStartTime) {
        headerHeight += 20
    }
    if (!props.filterByPunchHierarchy && showApproveIconOnBottom) {
        headerHeight += 10
    }

    return (
        <TableRow className="EmployeeTimecardTableHeader" style={{ height: headerHeight }}>
            {props.timecardDays.map((timecardDay, i) =>
                <EmployeeTimecardTableHeaderItem
                    userId={props.userId}
                    priorPeriodAdjustMode={props.priorPeriodAdjustMode}
                    timecardPriorPeriodData={props.timecardPriorPeriodData}
                    fullPunchSets={props.fullPunchSets}
                    hasDailyNote={props.dailyNoteDates.find(e => moment(timecardDay.LocalStartDayTime).isSameOrBefore(e) && moment(e).isSameOrBefore(timecardDay.LocalEndDayTime)) ? true : false}
                    filterByPunchHierarchy={props.filterByPunchHierarchy}
                    timecardDay={timecardDay}
                    lockData={props.lockData}
                    openDailyHistoryDrawer={props.openDailyHistoryDrawer}
                    date={i}
                    key={i}
                    handleApproveStatus={props.handleApproveStatus}
                    showApproveIconOnBottom={showApproveIconOnBottom}
                    loggedInUserType={props.loggedInUserType}
                    allowPriorPeriodAdjust={props.allowPriorPeriodAdjust}
                    suspensePunchData={props.suspensePunchData}
                    virtualTimecard={props.virtualTimecard}
                    handleOpenVirtualTimecardPopup={props.handleOpenVirtualTimecardPopup}
                    hideInfoIcon={props.hideInfoIcon}
                />
            )}
        </TableRow>
    )
}

export default EmployeeTimecardTableHeader
